'use client';

import { motion as motion_ } from 'motion/react';

import { toClassName } from 'helpers/format';

const motion: any = motion_;

type TProps = {
  as?: 'li' | 'div' | 'section' | 'h1' | 'h4';

  children: any;

  className?: string;
  id?: string;
};

const FadeInAnimation = (props: TProps) => {
  const as = props?.as ?? 'div';

  let component;

  const config = {
    className: toClassName('fade-in-animation-fallback', props?.className),
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    transition: { duration: 0.3, delay: 0.3, ease: 'easeOut' },
    viewport: { once: true },
    children: props?.children,
  };

  switch (as) {
    case 'li':
      component = <motion.li {...config} />;
      break;
    case 'div':
      component = <motion.div {...config} />;
      break;
    case 'section':
      component = <motion.section {...config} />;
      break;
    case 'h1':
      component = <motion.h1 {...config} />;
      break;
    case 'h4':
      component = <motion.h4 {...config} />;
      break;
  }

  return component;
};

export default FadeInAnimation;
